import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Reset de datos: solo administrador (`rol_id === 1`). */
export const mantenimientoAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.esRolAdministrador()) return true;
  return router.createUrlTree(['/app/parametros'], { queryParams: { acceso: 'denegado' } });
};
